module.exports = __webpack_public_path__ + "assets/static/png/mail.1d4763c3d98f72333ed7bb2359697aeb.png";


/*****************
 ** WEBPACK FOOTER
 ** ./app/pages/receipt/images/mail.png
 ** module id = 525
 ** module chunks = 1
 **/